<template>
  <div class="mb-6 border-b border-[#EEEEEE] pb-6 md:mb-8 md:pb-8">
    <slot />
  </div>
</template>
